import { Component, OnInit } from '@angular/core';
import { Ng2IziToastModule } from 'ng2-izitoast';
import { ClientesService } from 'src/app/services/clientes.service';
import { GruposService } from 'src/app/services/grupos.service';

@Component({
  selector: 'app-reporte-insumos',
  templateUrl: './reporte-insumos.component.html',
  styleUrls: ['./reporte-insumos.component.scss']
})
export class ReporteInsumosComponent implements OnInit {
  respuestGrupos:any;
  grupos:any;

  currentGrupo:any;
  gruposSeleccionados:any;
  existeGrupo = 0;
  constructor(private _getClientes:ClientesService, public iziToast: Ng2IziToastModule, 
    private _getGrupos: GruposService) { }

  ngOnInit(): void {
    this.getGrupos();
  }

  getGrupos(){
    this._getGrupos.getGruposNombre().subscribe(
      data => {
        this.respuestGrupos = data;
        if(this.respuestGrupos.success){
          this.grupos = this.respuestGrupos.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  agregarGrupoSeleccionado (){
    for(var i = 0; i<this.gruposSeleccionados.length; i++){
      if(this.gruposSeleccionados[i] == this.currentGrupo){
        this.existeGrupo = 1;
      } 
    }

    if(this.existeGrupo == 0){
      this.currentGrupo.push(this.currentGrupo);
    }
  }

  eliminarGrupoSeleccionado(grupo:number){
    for(var i = 0; i<this.gruposSeleccionados.length; i++){
      if(this.gruposSeleccionados[i] == grupo){
        this.gruposSeleccionados.splice(i, 1);
      } 
    }
  }

}
